var uppsellRecharge,  
    shop, 
    KinCart = function(e) { 
        var t = {};
        (this.init = function() {
            var e = localStorage.getItem("cartQuantity"),
                t = "1" === e ? " ITEM" : " ITEMS";
            $(".cart-quantity").html(e + t);
        }),
        (this.construct = function(e) {
            $.extend(t, e), this.init();
        }),
        this.construct(e);
    };
$(document).ready(function(e) {
   $(".clickable").click(function() {
  window.location = $(this).closest(".row").find("a:first-child").attr("href"); 
  return false;
});
        e(".callout");
        var t = e(".slideout-nav"),
            i = e(".nav-trigger"),
            a = e("body");
        e(".page-container").click(function() {
                a.hasClass("lock-scroll") && (a.removeClass("lock-scroll"), i.removeClass("close-nav"), e(".page-container").removeClass("block"), i.find("span").html("MENU"), t.removeClass("open"));
            }),
            i.on("click", function() {
                i.hasClass("close-nav") ?
                    (e(".site-nav").removeClass("no-shadow"), a.removeClass("lock-scroll"), i.removeClass("close-nav"), e(".page-container").removeClass("block"), i.find("span").html("MENU"), t.removeClass("open")) :
                    (a.addClass("lock-scroll"), e(".page-container").addClass("block"), i.addClass("close-nav"), i.find("span").html("CLOSE"), t.addClass("open"), e(".site-nav").addClass("no-shadow"));
            });
    }),
    $(function() {
        (cart = new KinCart({
            shop: shop,
        })),

        ($.fn.isInViewport = function() {
            var e = $(this).offset().top,
                t = e + $(this).outerHeight(),
                i = $(window).scrollTop(),
                a = i + $(window).height();
            return t > i && e < a;
        }),
        $(".cart-note").length && $(".cart-note").find("input[type=text], textarea").val(""),
            $(".cart__submit").click(function(e) {
                if ($(".cart-note").length && $(".cart-note__input").val().length) {
                    e.preventDefault(), $(".cart-note").slideToggle();
                    var t = "To: " + $("input[name=gift-to]").val() + "\nFrom: " + $("input[name=gift-from]").val() + "\n" + $(".cart-note__input").val();
                    $(".cart-note__input").val(t), $("input[name=checkout]").trigger("click");
                } else $("input[name=checkout]").trigger("click");
            }),
            $("[name=checkout]").click(function() {
                var e = [];
                $("tr.cart__row:visible").each(function() {
                        var t = $(this).find(".cart__qty-input").val();
                        $(this).find(".list-view-item__title").text().indexOf("Spritz") > -1 &&
                            e.push({
                                product: "Kin Spritz",
                                quantity: t,
                            });
                    }),
                    pintrk("track", "Checkout", {
                        total: $.trim($(".cart__subtotal").text()),
                        lineItems: e,
                    });
            }),
            $(".show-holiday-notes").click(function() {
                $(".cart-note__wrapper").slideToggle();
            }),
            $(".pdp-recipe").length &&
            new Swiper(".pdp-recipe", {
                spaceBetween: 30,
                pagination: {
                    el: ".pdp-swiper-pagination",
                },
            }),
            $("input:checked").trigger("change"),
            $("select").trigger("change");
    }),
    $("#ReCharge").length &&
    $(".rc_schedule__order__item__product, .rc_subscriptions__subscription__item__product").each(function() {
        var e = $.trim($(this).text()),
            t = "";
        (t = e), $(this).text(t);
    });
var recharge = setInterval(function() {
    $(".rc_popup__hover").length &&
        (clearInterval(recharge),
            $(".rc_popup__hover").find("img").remove(),
            $(".rc_popup__hover").prepend('<img class="rc_popup__icon" height="21" width="18" src="https://cdn.shopify.com/s/files/1/2708/7620/files/recharge-icon_1.png?v=1624382497" />'),
            $(".rc_popup__hover").find("img").show());
}, 500);

function getUrlVars(e) {
    for (var t, i = [], a = e.slice(e.indexOf("?") + 1).split("&"), n = 0; n < a.length; n++)(t = a[n].split("=")), i.push(t[0]), (i[t[0]] = t[1]);
    return i;
}
$("body").on("click", ".mini-minus", function(e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    var qty = parseFloat($(this).attr("data-qty")) - 1;
    Shopify.changeItem(variant_id, qty);
});
$("body").on("click", ".btn.mini", function(e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    if ($('.info-stats').attr("data-wholesale") != "") {
    if (parseInt($(".cart-count").text()) >= parseInt($('.info-stats').attr("data-wholesale"))) {
      $('#wholesale-modal').show();  
      return false;
    }else{
      $('#wholesale-modal').hide();
    }
  } 
    Shopify.addItem(variant_id);
   
});

$("body").on("click", ".gift", function(e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    if ($('.info-stats').attr("data-wholesale") != "") {
    if (parseInt($(".cart-count").text()) >= parseInt($('.info-stats').attr("data-wholesale"))) {
      $('#wholesale-modal').show();  
      return false;
    }else{
      $('#wholesale-modal').hide();
    }
  } 
    Shopify.addItem(variant_id);
   
});



$("body").on("click", ".mini-sub", function(e) {
    e.preventDefault();
  if ($(this).attr("data-up") === 'true'){
    var bundleToUpdate = $(this).closest(".bundled-group").attr("data-bundle");

    updateBundleSub(bundleToUpdate);   
    }else{
    var index = $(this).attr("data-index");
    var qty = $(this).attr("data-qty");
    var selling_plan = $(this).attr("data-selling-plan");
  
    Shopify.upgrade(index, qty, selling_plan); 
    }
     
});

$("body").on("click", ".mini-plus", function(e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    var qty = parseFloat($(this).attr("data-qty")) + 1;
     if ($('.info-stats').attr("data-wholesale") != "") {
    if (parseInt($(".cart-count").text()) >= parseInt($('.info-stats').attr("data-wholesale"))) {
      $('#wholesale-modal').show();  
      return false;
    }else{
      $('#wholesale-modal').hide();
    }
  } 
    Shopify.changeItem(variant_id, qty);
});
$("body").on("click", ".mini-remove", function(e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    Shopify.removeItem(variant_id);
});

$("body").on("click", ".plus-disabled", function(e) {
    e.preventDefault();
    $('#wholesale-modal').show();  
});

$("body").on("click", ".giftnote", function(e) {
    e.preventDefault();
    $('.cart-note__wrapper').show();  
 });

$("body").on("click", ".save-note", function(e) {
 e.preventDefault();

    var note=$(".cart-note__input").val();
    
   var data = {
       "note": note
    }
    var a = {
        type: "POST",
        url: "/cart/update.js",
        data: data,
        dataType: "json",
        success: function(t) {
            $('.cart-note__wrapper').hide(); 
          if (note ===""){
            $('.giftnote-wrapper .og-message').show();
            $('.giftnote-wrapper .full-message').hide();
          }
            else{
              $('.giftnote-wrapper .og-message').hide();
              $('.giftnote-wrapper .message').html("Gift Note: " +note);
              $('.giftnote-wrapper .full-message').show();
           
          }
        },
        error: function(t, r) {},
    };
    jQuery.ajax(a);
  


    

  });
$("body").on("click", ".cancel-note", function(e) {
 e.preventDefault();
      $('.cart-note__wrapper').hide();   		
  });

function updateDrawer(type) {
    var skio = "false";
    var bundle = "false";
    fetch("/cart.js")
        .then((resp) => resp.json())
        .then((data) => {

            if (data.items.length > 0) {
                $(".cart__drawer_items").html("");
                data.items.forEach(function(product, index) {
                    var itemprice = "";
                    var subtitle = "";
                    var hiddenstyle="";
                    var isSub = "";
                    var isSubId = "";
                     var classinclude = "";
                  var title = product.product_title;
                  title = title.substring(0, title.indexOf('('));
                
                   
                   itemprice = ' <span class="total">' + theme.Currency.formatMoney(product.line_price, theme.moneyFormat) + "</span>";
                   var proImg = product.featured_image.url;
                   var newimg = "";
                   
                   if (proImg.indexOf('.png') != -1) {
                    newimg = proImg.replace(".png", "_150x.png");
                     
                   }else if(proImg.indexOf('.jpg') != -1) {
                    newimg = proImg.replace(".jpg", "_150x.jpg");
                   }else{
                     newimg = proImg;
                   }
                   if (product.selling_plan_allocation) {
                        skio = "true";
                       subtitle = product.selling_plan_allocation.selling_plan.name;
                       isSub = "true";
                       isSubId=$('.info-stats .v-'+ product.variant_id).attr('selling_plan');
                    }else{
                      if($('.info-stats .v-'+ product.variant_id).attr("selling_plan") !== ""){
                        subtitle="One Time<br><a href='' class='mini-sub' data-id='"+product.variant_id+"' data-index='"+ (index + 1) +"' data-qty='"+product.quantity+"' data-selling-plan='"+$('.info-stats .v-'+ product.variant_id).attr('selling_plan')+"'>Subscribe & Save</a>";
                      }else{
                        if (product.title == "Bliss Duet"){
                          subtitle='One Time<br><a class="gift" href="/cart/add.js?id=32164697178154&quantity=1" data-id="32164697178154">Gift Wrap for $6?</a>';
                          classinclude = "bliss-included";
                        }
                          else{
                          subtitle="One Time";
                          }
                        if (product.title == "Kin Gift Wrap"){
                           hiddenstyle = "hidden";
                           classinclude = "giftwrap-included";
                        }
                      }
                     isSubId=$('.info-stats .v-'+ product.variant_id).attr('selling_plan');
                     isSub = "false";
                    }

                    var newtitle = $('.info-stats .v-'+ product.variant_id).attr("data-title"),
                      newsubtitle = $('.info-stats .v-'+ product.variant_id).attr("data-vtitle");

                      if(!newtitle) {
                        newtitle = product.product_title;
                       }
                  
                    let obj = {};
                    obj = product.properties;
                    let isEmpty = $.isEmptyObject(obj);

                    var bundleid="";
                      if (isEmpty === false){
                        
                        for (const [key, value] of Object.entries(obj)) {
                        const keyn=`${key}`;
                        const valn=`${value}`;
                          if (keyn == "Bundle"){
                             bundleid=valn;
                          }
                      } 
                      }                 
                   if (bundleid != ""){
                     bundle = "true";
                     var bundeName = "";
                     if (bundleid == "bundle-cans"){
                       bundeName = "Cans Bundle";
                     }
                     if (bundleid == "bundle-mixed"){
                       bundeName = "Mixed Bundle";
                     }
                     if (bundleid == "bundle-bottles"){
                       bundeName = "Bottles Bundle";
                     }
                     $(".cart__drawer_items").append(
                            '<tr class="cart__row border-bottom line1 border-top bundled '+bundleid+' row-wrapper-cart" style="display:none;" data-index="'+ (index + 1) +'" data-sub="'+isSub+'" data-sub-id="'+isSubId+'" data-price="'+product.line_price+'" data-type="'+product.product_type+'" data-qty="'+product.quantity+'" "data-handle="' +
                            product.handle +
                            '" data-bundle="' +
                            bundleid +
                            '" data-id="' + product.variant_id + '"><td class="cart__image-wrapper"><img src="' +
                            newimg +
                            '" alt="' +
                            product.featured_image.alt +
                            '"></div></td><td class="cart__meta small--text-left"><div class="list-view-item__title"><div class="title">' +
                            newtitle +
                            '</div><div class="price-wrapper">' +
                            itemprice + 
                            '</div><div class="sub-wrapper">' +bundeName+'<br>' +
                            product.quantity+'x '+ (product.variant_title != null ? product.variant_title : '' ) + ' ' + (product.product_type == 'Beverages' ? 'Cans' : product.product_type) + (product.variant_title > 1 && product.product_type == 'Bottle' ? 's' : '') + '<br>' +
                            subtitle +
                            '</div><div class="delete"><a class="bundle-remove">x</a></div> </div></td>"' +
                            "</tr>"
                        );
                   }
                   else if (product.price > 0) {
                        $(".cart__drawer_items").append(
                            '<tr class="cart__row border-bottom line1 border-top row-wrapper-cart '+classinclude+'" data-handle="' +
                            product.handle +
                            '" data-id="' + product.variant_id + '"><td class="cart__image-wrapper"><img src="' +
                            newimg +
                            '" alt="' +
                            product.featured_image.alt +
                            '"></div></td><td class="cart__meta small--text-left"><div class="list-view-item__title"><div class="title">' +
                            newtitle +
                            '</div><div class="price-wrapper">' +
                            itemprice + 
                            '</div><div class="sub-wrapper">' +
                            product.quantity+'x '+ (product.variant_title != null ? product.variant_title : '' ) + ' ' + (product.product_type == 'Beverages' ? 'Cans' : product.product_type) + (product.variant_title > 1 && product.product_type == 'Bottle' ? 's' : '') + '<br>' +
                            subtitle +
                            '</div><div class="delete"><a href="/cart/change?quantity=0&id=' +
                            product.variant_id +
                            '" data-id="' +
                            product.variant_id +
                            '" class="mini-remove">x</a></div> <div class="qty-wrapper '+hiddenstyle+' "><a href="/cart/change?quantity=1&id=' +
                            product.variant_id +
                            '" class="mini-minus" data-id="' +
                            product.variant_id +
                            '" data-qty="' +
                            product.quantity +
                            '">-</a>' +
                            '<input type="text" value="' +
                            product.quantity +
                            '" readonly  />' +
                            '<a href="/cart/change?quantity=1&id=' +
                            product.variant_id +
                            '" class="mini-plus" data-id="' +
                            product.variant_id +
                            '" data-qty="' +
                            product.quantity +
                            '">+</a>' +
                            "</div></div></td>" +
                            "</tr>"
                        );
                    } else {
                        $(".cart__drawer_items").append(
                            '<tr class="cart__row gift-included border-bottom line1 border-top row-wrapper-cart" data-handle="' +
                            product.handle +
                            '" ga="' + product.variant_id + '"><td class="cart__image-wrapper"><img src="' +
                            newimg +
                            '" alt="' +
                            product.featured_image.alt +
                            '"></div></td><td class="cart__meta small--text-left"><div class="list-view-item__title"><div class="title">' +
                            product.product_title +
                            '</div><div class="sub-wrapper">' +
                            product.quantity+'x Free Gift   <br>One Time' +
                            '</div><div class="price-wrapper">Free</div></div></td></tr>'
                        );
                    }
                });
                $(".drawer_total_amount").html(theme.Currency.formatMoney(data.total_price, theme.moneyFormat));
                $(".cart-count").html(data.item_count);
               $(".button-group").show();
              if(skio == 'true'){
                    $(".button-group .afterpay-placeholder").hide();
                    $(".dynamic-checkout__title").hide();
                    $(".additional-checkout-buttons").show();
                    $(".additional-checkout-buttons [data-shopify-buttoncontainer] li").each(function() {
                        let isShopPay = $(this).find('[data-testid="ShopifyPay-button"]').length ? true : false;
                        !isShopPay ? $(this).hide() : null;
                    });                    
                }else{
                    $(".dynamic-checkout__title").show();
                    $(".button-group .afterpay-placeholder").show()
                    $(".additional-checkout-buttons").show();
                    $(".additional-checkout-buttons [data-shopify-buttoncontainer] li").each(function() {
                        let isShopPay = $(this).find('[data-testid="ShopifyPay-button"]').length ? true : false;
                        !isShopPay ? $(this).hide() : null;
                    });                    
                }
                $(".other-cart-item").show();
                $(".upsell-wrapper-top").show();
                $(".cart__drawer_items .cart__row").each(function(index) {
                    var look = $(this).attr('data-id');
                     var looktitle = $(this).find(".title").html();
                    $(".upsell").find("[data-title='" + looktitle + "']").hide();
                    $(".upsell").find("[data-top='" + look + "']").hide();
                    $(".upsell-top").find("[data-top='" + look + "']").hide();
                
                });
                if ($('.other-cart-item:not([style*="display: none"])').length == 0) {
                    $(".upsell").hide();
                   $(".cart__root .upsell").hide();
                  
                } else {
                    var containerwidth = parseInt($('.other-cart-item:not([style*="display: none"])').length * 130) + "px";
                    $(".cart .scrollable-wrapper .scroll").css("width", containerwidth);
                    $(".upsell").show();
                }
                if ($('.upsell-wrapper-top:not([style*="display: none"])').length == 0) {
                    $(".upsell-top").hide();
                } else {
                    $(".upsell-top").show();
                }
                $(".table-wrapper").removeClass("full-height");
              
           
              if(data.total_price >= $('.cart-pull').attr('data-ship-tres')){
                 $(".drawer__shipping p").html("You've unlocked free shipping <style>.shipping-container .Loading:after {width: 100%!important;}@keyframes load {0% {width: 0;background: #F5A623;}100% { width: 100%;background:  #F5A623;}}</style>");
              }else{
                var diff = $('.cart-pull').attr('data-ship-tres') - data.total_price;
                diff = theme.Currency.formatMoney(diff, theme.moneyFormat); 
                
                var perc =  (   data.total_price / $('.cart-pull').attr('data-ship-tres')) * 100;
                $(".drawer__shipping p").html(diff + ' away from free standard shipping<style>.shipping-container .Loading:after {width: '+perc+'%!important;}@keyframes load {0% {width: 0;background:#F5A623;}'+perc+'% { width: '+perc+'%;background:  #F5A623;}}</style>');
              }

            } else {
                $(".table-wrapper").addClass("full-height");
                $(".drawer__shipping p").html(theme.Currency.formatMoney($('.cart-pull').attr('data-ship-tres'), theme.moneyFormat) + ' away from free standard shipping');
                $(".cart__drawer_items").html('<tr class="cart__row_empty"><td><br><p>Your Cart is Empty</p><br><a href="/pages/shop-all" class="btn">Keep Shopping </a></td></tr>');
                $(".cart-count").html(data.item_count);
                $(".button-group").hide();
                $(".other-cart-item").show();
                $(".upsell-wrapper-top").show();
                var containerwidth = parseInt($('.other-cart-item:not([style*="display: none"])').length * 130) + "px";
                $(".cart .scrollable-wrapper .scroll").css("width", containerwidth);
                $(".upsell").show();
                $(".upsell-top").show();
            }

            if (bundle == "true"){
                                 
              //loop through bundles
              //group together

              if ($('.cart__row.bundled.bundle-cans').length > 0 ){
              var bundleid = "";
              var productTitles = "";
              var priceTotal = "";
              var price = "";
              var subid="";
              
              var isSub="";
              var subtitleNew = "";
                bundleid = $(this).attr("data-bundle");
              $('.cart__row.bundled.bundle-cans').reverse().each(function(index) {
                isSub = $(this).attr("data-sub");
                subid = $(this).attr("data-sub-id");

                 if (isSub === "true") {
                       subtitleNew = "<i style='margin-top:3px;display:block;'>Monthly Subscription</i>"; 
                    }else{
                   subtitleNew = "<i style='margin-top:3px;display:block;'>One Time</i>"; 
                       //subtitleNew="One Time<br><a href='' class='mini-sub' data-up='true' data-id='"+$(this).attr("data-id")+"' data-qty='"+$(this).attr("data-qty")+"' data-selling-plan='"+subid+"'>Subscribe & Save</a>";
                    }
                productTitles = productTitles + parseInt($(this).attr("data-qty")*4) +" Cans " + $(this).find(".title").html() +"<br>";
                price = parseInt($(this).attr('data-price'));
                priceTotal = parseFloat(priceTotal + price);
               });
                priceTotal = ' <span class="total">' + theme.Currency.formatMoney(priceTotal, theme.moneyFormat) + "</span>";
                $(".cart__drawer_items").append(
                  '<tr class="cart__row border-bottom line1 border-top bundled-group bundle-cans row-wrapper-cart" data-bundle="bundle-cans"><td class="cart__image-wrapper"><img src="//cdn.shopify.com/s/files/1/2708/7620/files/0922_Web_BuildABundle_ChooseBundle_Cans_Hover__2x_497a12de-b31a-4b19-9a3d-1a40def42074.png?v=1664915727"></div></td><td class="cart__meta small--text-left"><div class="list-view-item__title"><div class="title">Cans Bundle</div><div class="price-wrapper">' 
                  + priceTotal + 
                 '</div><div class="sub-wrapper">' +productTitles+subtitleNew+'<br></div><div class="delete"><a class="bundle-remove">x</a></div> </div></td>"' +
                 "</tr>"
                );
            }
              
              if ($('.cart__row.bundled.bundle-mixed').length > 0 ){
              var bundleid = "";
              var productTitles = "";
              var priceTotal = "";
              var price = "";
              var subid="";
              var label = "";
              var isSub="";
              var subtitleNew = "";
                bundleid = $(this).attr("data-bundle");
              $('.cart__row.bundled.bundle-mixed').reverse().each(function(index) {
                 isSub = $(this).attr("data-sub");
                 subid = $(this).attr("data-sub-id");

                 if (isSub === "true") {
                       subtitleNew = "<i style='margin-top:3px;display:block;'>Monthly Subscription</i>"; 
                    }else{
                       //subtitleNew="One Time<br><a href='' class='mini-sub'  data-up='true' data-id='"+$(this).attr("data-id")+"' data-qty='"+$(this).attr("data-qty")+"' data-selling-plan='"+subid+"'>Subscribe & Save</a>";
                       subtitleNew = "<i style='margin-top:3px;display:block;'>One Time</i>"; 
                 }

                if ( $(this).attr("data-type") === "Cans"){
                     productTitles = productTitles + parseInt($(this).attr("data-qty")*4) +" Cans " + $(this).find(".title").html() +"<br>";
                  
                }else{
                  if(parseInt($(this).attr("data-qty")) > "1"){
                     productTitles = productTitles + $(this).attr("data-qty") +" Bottles " + $(this).find(".title").html()  +"<br>";
                    }else{
                    productTitles = productTitles + $(this).attr("data-qty") +" Bottle " + $(this).find(".title").html()  +"<br>";
                    }
                }
                
                
                price = parseInt($(this).attr('data-price'));
                priceTotal = parseFloat(priceTotal + price);
               });
                priceTotal = ' <span class="total">' + theme.Currency.formatMoney(priceTotal, theme.moneyFormat) + "</span>";
                $(".cart__drawer_items").append(
                  '<tr class="cart__row border-bottom line1 border-top bundled-group bundle-mixed row-wrapper-cart" data-bundle="bundle-mixed"><td class="cart__image-wrapper"><img src="//cdn.shopify.com/s/files/1/2708/7620/files/0922_Web_BuildABundle_ChooseBundle_Mix_Hover__2x_c5ee7075-0c5b-431f-bd84-87e3f572419a.png?v=1664915727"></div></td><td class="cart__meta small--text-left"><div class="list-view-item__title"><div class="title">Mixed Bundle</div><div class="price-wrapper">' 
                  + priceTotal + 
                 '</div><div class="sub-wrapper">' +productTitles+subtitleNew+'<br></div><div class="delete"><a class="bundle-remove">x</a></div> </div></td>"' +
                 "</tr>"
                );
            }

              if ($('.cart__row.bundled.bundle-bottles').length > 0 ){
                
                var bundleid = "";
              var productTitles = "";
              var priceTotal = "";
              var price = "";
              var label = "";
              var subid="";
              var isSub="";
              var subtitleNew = "";
                bundleid = $(this).attr("data-bundle");
              $('.cart__row.bundled.bundle-bottles').reverse().each(function(index) {
                 isSub = $(this).attr("data-sub");
                 subid = $(this).attr("data-sub-id");

                 if (isSub === "true") {
                       subtitleNew = "<i style='margin-top:3px;display:block;'>Monthly Subscription</i>"; 
                    }else{
                       //subtitleNew="One Time<br><a href='' class='mini-sub'  data-up='true' data-id='"+$(this).attr("data-id")+"' data-qty='"+$(this).attr("data-qty")+"' data-selling-plan='"+subid+"'>Subscribe & Save</a>";
                 subtitleNew = "<i style='margin-top:3px;display:block;'>One Time</i>";     
                 }

                
                if(parseInt($(this).attr("data-qty")) > "1"){
                  label="Bottles"
                }else{
                  label="Bottle"
                }
                productTitles = productTitles + $(this).attr("data-qty") +" "+label+" " + $(this).find(".title").html()  +"<br>";
                price = parseInt($(this).attr('data-price'));
                priceTotal = parseFloat(priceTotal + price);
               });
                priceTotal = ' <span class="total">' + theme.Currency.formatMoney(priceTotal, theme.moneyFormat) + "</span>";
                $(".cart__drawer_items").append(
                  '<tr class="cart__row border-bottom line1 border-top bundled-group bundle-bottles row-wrapper-cart" data-bundle="bundle-bottles""><td class="cart__image-wrapper"><img src="https://cdn.shopify.com/s/files/1/2708/7620/files/0922_Web_BuildABundle_ChooseBundle_Bottles_Hover__2x_e514d961-cbe6-49f3-82d2-9b0234bcf31b.png?v=1664915727"></div></td><td class="cart__meta small--text-left"><div class="list-view-item__title"><div class="title">Bottles Bundle</div><div class="price-wrapper">' 
                  + priceTotal + 
                 '</div><div class="sub-wrapper">' +productTitles+subtitleNew+'<br></div><div class="delete"><a class="bundle-remove">x</a></div> </div></td>"' +
                 "</tr>"
                );
            }
            
               
               
            }
            if ($('.cart-pull').attr('data-gwp-on') === 'true') {
                var isThresholdGift = $('.cart-pull').attr('data-tres') != "" && $('.cart-pull').attr('data-tres') != null;
                var isSubscriptionGift = $('.cart-pull').attr('data-gwp-subscriptions-only') === 'true';
                if (isThresholdGift || isSubscriptionGift) {
                    var access = "yes";
                    if ($('.cart-pull').attr('data-keyvalue') != "" && $('.cart-pull').attr('data-keyvalue') != null) {
                        
                      let promo = getCookie('promo');
                        if (promo != null && promo.length > 1) {
                            if (promo == $('.cart-pull').attr('data-keyvalue')) {
                                access = "yes";
                            } else {
                                access = "no";
                            }
                        } else {
                            access = "no";
                        }
                    }

                    var myDate = new Date();
                    var start = new Date($('.cart-pull').attr("data-start"));
                    var end = new Date($('.cart-pull').attr("data-end"));
                    var dateshow = "no";

                    if (start <= myDate && end >= myDate) {
                        dateshow = "yes";
                    }

                    var carttotal = data.total_price;
                    var cartHasSubscription = data.items?.some(item => item.selling_plan_allocation);
                    var isThresholdQualified = isThresholdGift && data.total_price > $('.cart-pull').attr('data-tres');
                    var isSubscriptionQualified = isSubscriptionGift && cartHasSubscription;
                    var isQualified = (!isThresholdGift || (isThresholdGift && isThresholdQualified)) && (!isSubscriptionGift || (isSubscriptionGift && isSubscriptionQualified));
                    if (isQualified && access == "yes" && dateshow == "yes") {
                        var getid = $('.cart-pull').attr('data-up');
                        if ($('.cart__drawer_items .gift-included').length == 0) {
                            Shopify.addItem(getid);
                        }
                    } else {
                        if ($('.cart__drawer_items .gift-included').length > 0) {
                            $('.cart__drawer_items .gift-included').each(function() {
                                var getidr = $(this).attr('ga');
                                Shopify.removeItem(getidr);
                            });
                        }
                    }
                } else if ($('.gwp-modal').length > 0) {
                  // modals
                    var myDate = new Date();
                    $('.gwp-modal').hide();
                    var toggle = "false";
                    var carttotal = data.total_price;
                    var lowestmin = "";

                    $('.gwp-modal').each(function(index) {
                        var earlyaccessonly = "no";
                        let upsellCookie = getCookie('earlyaccess');
                        if (upsellCookie != null && upsellCookie.length > 1) {
                            earlyaccessonly = "yes";
                        }

                        var start = new Date($(this).attr("data-start"));
                        var end = new Date($(this).attr("data-end"));
                        var dateshow = "false";

                        if (start <= myDate && end >= myDate) {
                            dateshow = "true";
                        }

                        if (index == 0) {
                            lowestmin = $(this).attr("data-min");
                        }

                        var earlyonly = $(this).attr("data-early");
                        var id1 = $(this).attr("data-id1");
                        var id2 = $(this).attr("data-id2");
                        var keyw = $(this).attr("data-keyword");
                        var min = $(this).attr("data-min");
                        var max = $(this).attr("data-max");

                        var included = false;

                        $('.cart__row .list-view-item__title .title').each(function() {
                            if ($(this).html().indexOf(keyw) != -1) {
                                included = true;
                            }
                        });

                        if (carttotal > min && carttotal < max && dateshow == "true") {

                            if ($('.cart__drawer_items .gift-included').length == 0) {
                                if (earlyonly == "true") {
                                    if (earlyaccessonly == "yes") {
                                        $(this).show();
                                    }
                                } else {
                                    $(this).show();
                                }
                            } else {
                                if ($('.cart__drawer_items .gift-included').length > 0) {
                                    $('.cart__drawer_items .gift-included').each(function() {
                                        var getidr = $(this).attr('ga');

                                        if (getidr != id1 && getidr != id2) {
                                            Shopify.removeItem(getidr);
                                        }
                                    });
                                }
                            }
                            return false;
                        } else if (included == true && dateshow == "true") {

                            if ($('.cart__drawer_items .gift-included').length == 0) {
                                if (earlyonly == "true") {
                                    if (earlyaccessonly == "yes") {
                                        $(this).show();
                                    }
                                } else {
                                    $(this).show();
                                }
                            } else {
                                if ($('.cart__drawer_items .gift-included').length > 0) {
                                    $('.cart__drawer_items .gift-included').each(function() {
                                        var getidr = $(this).attr('ga');

                                        if (getidr != id1 && getidr != id2) {
                                            Shopify.removeItem(getidr);
                                        }
                                    });
                                }
                            }
                            return false;
                        } else {
                            if (carttotal < min) {
                                if ($('.cart__drawer_items .gift-included').length > 0) {
                                    $('.cart__drawer_items .gift-included').each(function() {
                                        var getidr = $(this).attr('ga');
                                        if (getidr == id1 || getidr == id2) {
                                            Shopify.removeItem(getidr);
                                        }
                                    });
                                }
                            }
                            if (keyw != "") {
                                if ($('.cart__drawer_items .gift-included').length > 0) {
                                    $('.cart__drawer_items .gift-included').each(function() {
                                        var getidr = $(this).attr('ga');
                                        if (getidr == id1 || getidr == id2) {
                                            Shopify.removeItem(getidr);
                                        }
                                    });
                                }
                            }
                        }
                    });
                }
            } else {
                if ($('.cart__drawer_items .gift-included').length > 0) {
                    $('.cart__drawer_items .gift-included').each(function() {
                        var getidr = $(this).attr('ga');
                        Shopify.removeItem(getidr);
                    });
                }
            }
          

            if ($('.cart__drawer_items .gift-included').length == $('.cart__drawer_items .cart__row').length) {
                $('.cart__drawer_items .gift-included').each(function() {
                    var getidr = $(this).attr('ga');
                    Shopify.removeItem(getidr);
                });
            }

         if ($('.cart__drawer_items .giftwrap-included').length > 0) {
            $('.cart__drawer_items .bliss-included .gift').remove();
         }else{
           $('.cart__drawer_items .bliss-included .gift').show();
           
         }
          if ($('.cart__drawer_items .giftwrap-included').length > 0 && $('.cart__drawer_items .bliss-included').length == 0) {
                $('.cart__drawer_items .giftwrap-included').each(function() {
                    var getidr = $(this).attr('data-id');
                        Shopify.removeItem(getidr);
                });
            }
          
          
             
            
        });
}

$(document).ready(function() {
    $('.gwp-modal .close').on("click", function(t) {
        $('.gwp-modal').hide();
    });
});


Shopify.addItemToCart = function(variant_id, selling_plan, qty) {
  if ($('.info-stats').attr("data-wholesale") != "") {
    if (parseInt($(".cart-count").text()) >= parseInt($('.info-stats').attr("data-wholesale"))) {
      $('#wholesale-modal').show();  
      return false;
    }else{
      $('#wholesale-modal').hide();
    }
  } 

    var data = {
        "id": variant_id,
        "quantity": qty,
        selling_plan
    }
    jQuery.ajax({
        type: 'POST',
        url: '/cart/add.js',
        data: data,
        dataType: 'json',
        success: function() {
          //geq.addToCart(variant_id);
          //console.log("add"+variant_id);
     
            updateDrawer("add");
        }
    });
};
Shopify.addItem = function(t, r) {
  if ($('.info-stats').attr("data-wholesale") != "") {
    if (parseInt($(".cart-count").text()) >= parseInt($('.info-stats').attr("data-wholesale"))) {
      $('#wholesale-modal').show();  
      return false;
    }else{
      $('#wholesale-modal').hide();
    }
  } 
  var id = t;
    var data = {
        "id": t,
        "quantity": "1"
    }
    var a = {
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function(t) {
            updateDrawer("add");
         // geq.addToCart(id);
         // console.log("add"+id);
           if ($('.template-cart').length > 0) {
      window.location.href = "/cart/";
    }
        },
        error: function(t, r) {},
    };
    jQuery.ajax(a);
  
  
};
Shopify.addSub = function(t, r, freq,unit) {
  if ($('.info-stats').attr("data-wholesale") != "") {
    if (parseInt($(".cart-count").text()) >= parseInt($('.info-stats').attr("data-wholesale"))) {
      $('#wholesale-modal').show();  
      return false;
    }else{
      $('#wholesale-modal').hide();
    }
  } 
    var data = {
        "id": t,
        "quantity": r,
        "properties": {
            "shipping_interval_frequency": 1,
            "shipping_interval_unit_type": unit
        }
    }
    var a = {
        type: "POST",
        url: "/cart/add.js",
        data: data,
        dataType: "json",
        success: function(t) {
            updateDrawer("add");
           if ($('.template-cart').length > 0) {
      window.location.href = "/cart/";
    }
        },
        error: function(t, r) {},
    };
    jQuery.ajax(a);
  
};
(Shopify.changeItem = function(t, r, e) {
    var a = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=" + r + "&id=" + t,
        dataType: "json",
        success: function(t) {
            updateDrawer("change");
        },
        error: function(t, r) {},
    };
    jQuery.ajax(a);
}),
 
  
(Shopify.remove = function(t, r, newV, qty, selling_plan) {
    var data = {
        "id": t,
        "quantity": r
    }
    var a = {
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function(t) {
            Shopify.addSub(newV,qty,selling_plan);
        },
        error: function(t, r) {},
    };
    jQuery.ajax(a);
});
(Shopify.upgrade = function(line, quantity, selling_plan) {
    var data = {
        line,
        quantity,
        selling_plan
    }
    var a = {
        type: "POST",
        url: "/cart/change.js",
        data: data,
        dataType: "json",
        success: function(t) {
            updateDrawer("add");
        },
        error: function(t, r) {},
    };
    jQuery.ajax(a);
});

(Shopify.removeItemLineLast = function(t, data) {  
    var e = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + t,
        dataType: "json",
        success: function(t) {
          Shopify.addItemLine(data);
          updateDrawer("remove");
        },
        error: function(t) {},
    };
    jQuery.ajax(e);
});

(Shopify.addItemLine = function(data) {  
      fetch('/cart/add.js', {
      body: JSON.stringify(data),
      credentials: 'same-origin',
      headers: {
        'Content-Type': 'application/json',
        'X-Requested-With':'xmlhttprequest'
      },
      method: 'POST'
    }).then((response) => {
      return response.json();
    }).then((json) => {
      /* yay! our products were added - do something here to indicate to the user */
        updateDrawer("add");
        alert("adding");
    }).catch((err) => {
      /* uh oh, we have error. */
      console.error(err)
    });     
});

(Shopify.removeItemLine = function(t, r) {  
    var e = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + t,
        dataType: "json",
        success: function(t) {
          
        },
        error: function(t, r) {},
    };
    jQuery.ajax(e);
});

(Shopify.removeItem = function(t, r) {
    var e = {
        type: "POST",
        url: "/cart/change.js",
        data: "quantity=0&id=" + t,
        dataType: "json",
        success: function(t) {
            updateDrawer("remove");
        },
        error: function(t, r) {},
    };
    jQuery.ajax(e);
});
$(document).ready(function() {
    updateDrawer("load");
  function waitForElm(selector) {
        return new Promise(resolve => {
            if (document.querySelector(selector)) {
                return resolve(document.querySelector(selector));
            }

            const observer = new MutationObserver(mutations => {
                if (document.querySelector(selector)) {
                    resolve(document.querySelector(selector));
                    observer.disconnect();
                }
            });

            observer.observe(document.body, {
                childList: true,
                subtree: true
            });
        });
    };

    waitForElm('[data-shopify-buttoncontainer]').then((el) => {
        console.log('element found')
        $(".additional-checkout-buttons [data-shopify-buttoncontainer] li").each(function() {
            let isShopPay = $(this).find('[data-testid="ShopifyPay-button"]').length ? true : false;
            !isShopPay ? $(this).hide() : null;
        });     
    })
});
(window.theme = window.theme || {}),
(theme.Currency = (function() {
    var e = "${{amount}}";
    return {
        formatMoney: function(t, i) {
            "string" == typeof t && (t = t.replace(".", ""));
            var a = "",
                n = /\{\{\s*(\w+)\s*\}\}/,
                o = i || e;

            function s(e, t, i, a) {
                if (((i = i || ","), (a = a || "."), isNaN(e) || null === e)) return 0;
                var n = (e = (e / 100).toFixed(t)).split(".");
                return n[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + i) + (n[1] ? a + n[1] : "");
            }
            switch (o.match(n)[1]) {
                case "amount":
                    a = s(t, 2);
                    break;
                case "amount_no_decimals":
                    a = s(t, 0);
                    break;
                case "amount_with_comma_separator":
                    a = s(t, 2, ".", ",");
                    break;
                case "amount_no_decimals_with_comma_separator":
                    a = s(t, 0, ".", ",");
                    break;
                case "amount_no_decimals_with_space_separator":
                    a = s(t, 0, " ");
                    break;
                case "amount_with_apostrophe_separator":
                    a = s(t, 2, "'");
            }
            return o.replace(n, a);
        },
    };
})()),
(function() {
    var e = $(".return-link");

    function t(e) {
        var t = document.createElement("a");
        return (t.ref = e), t.hostname;
    }
    document.referrer &&
        e.length &&
        window.history.length &&
        e.one("click", function(e) {
            e.preventDefault();
            var i = t(document.referrer);
            return t(window.location.href) === i && history.back(), !1;
        });
})(),
(theme.FormStatus = (function() {
    var e = {
        statusMessage: "[data-form-status]",
    };
    return {
        init: function() {
            (this.$statusMessage = $(e.statusMessage)), this.$statusMessage && this.$statusMessage.focus();
        },
    };
})()),
(window.theme = theme || {}),
(theme.customerTemplates = (function() {
    function e() {
        $("#RecoverPasswordForm").toggleClass("hide"), $("#CustomerLoginForm").toggleClass("hide");
    }
    return {
        init: function() {
            var t;
            "#recover" === window.location.hash && e(),
                $("#RecoverPassword").on("click", function(t) {
                    t.preventDefault(), e();
                }),
                $("#HideRecoverPasswordLink").on("click", function(t) {
                    t.preventDefault(), e();
                }),
                $(".reset-password-success").length && $("#ResetSuccess").removeClass("hide"),
                (t = $("#AddressNewForm")).length &&
                (Shopify &&
                    new Shopify.CountryProvinceSelector("AddressCountryNew", "AddressProvinceNew", {
                        hideElement: "AddressProvinceContainerNew",
                    }),
                    $(".address-country-option").each(function() {
                        var e = $(this).data("form-id"),
                            t = "AddressCountry_" + e,
                            i = "AddressProvince_" + e,
                            a = "AddressProvinceContainer_" + e;
                        new Shopify.CountryProvinceSelector(t, i, {
                            hideElement: a,
                        });
                    }),
                    $(".address-new-toggle").on("click", function() {
                        t.toggleClass("hide");
                    }),
                    $(".address-edit-toggle").on("click", function() {
                        var e = $(this).data("form-id");
                        $("#EditAddress_" + e).toggleClass("hide");
                    }),
                    $(".address-delete").on("click", function() {
                        var e = $(this),
                            t = e.data("form-id"),
                            i = e.data("confirm-message");
                        confirm(i || "Are you sure you wish to delete this address?") &&
                            Shopify.postLink("/account/addresses/" + t, {
                                parameters: {
                                    _method: "delete",
                                },
                            });
                    }));
        },
    };
})()),
(theme.Cart = (function() {
    var e = {
            edit: ".js-edit-toggle",
            inputQty: ".cart__qty-input",
            thumbnails: ".cart__image",
            item: ".cart__row",
        },
        t = {
            showClass: "cart__update--show",
            showEditClass: "cart__edit--active",
            cartNoCookies: "cart--no-cookies",
        };

    function i(i) {
        (this.$container = $(i)),
        (this.$edit = $(e.edit, this.$container)),
        (this.$inputQuantities = $(e.inputQty, this.$container)),
        (this.$thumbnails = $(e.thumbnails, this.$container)),
        this.cookiesEnabled() || this.$container.addClass(t.cartNoCookies),
            this.$edit.on("click", this._onEditClick),
            this.$inputQuantities.on("change", this._handleInputQty),
            this.$thumbnails.css("cursor", "pointer"),
            this.$thumbnails.on("click", this._handleThumbnailClick);
    }
    return (
        (i.prototype = _.assignIn({}, i.prototype, {
            onUnload: function() {
                this.$edit.off("click", this._onEditClick);
            },
            _onEditClick: function(e) {
                var i = $(e.target),
                    a = $("." + i.data("target")),
                    n = "true" === i.attr("aria-expanded");
                i.toggleClass(t.showEditClass).attr("aria-expanded", !n), a.toggleClass(t.showClass);
            },
            _handleInputQty: function(e) {
                var t = $(e.target),
                    i = t.val(),
                    a = t.data("quantity-item");
                $("[data-quantity-item=" + a + "]").val(i);
            },
            _handleThumbnailClick: function(e) {
                var t = $(e.target).data("item-url");
                window.location.href = t;
            },
            cookiesEnabled: function() {
                var e = navigator.cookieEnabled;
                return e || ((document.cookie = "testcookie"), (e = -1 !== document.cookie.indexOf("testcookie"))), e;
            },
        })),
        i
    );
})()),
    (theme.init = function () {
        theme.customerTemplates.init();     
            $('a[href="#"]').on("click", function (e) {
                e.preventDefault();
            }),
            theme.FormStatus.init();
    }),
    $(theme.init),
    $(document).ready(function() {
        var e = Math.floor(Math.random() * $(".article").length),
            t = Math.floor(Math.random() * $(".article").length);
        e === t && (t = Math.floor(Math.random() * $(".article").length - 1)), $(".article").eq(e).show(), $(".article").eq(t).show(), $(".article:hidden").remove();

    }),
    jQuery(document).on("click", ".modal-faq", function(e) {
        var t = jQuery(this).attr("data-product");
        jQuery('.modal-' + t).show();
    }),
    jQuery(document).on("click", ".modal-faq", function(e) {
        var t = jQuery(this).attr("data-product");
        jQuery('.modal-' + t).show();
    }),
    $('.btn[data-toggle="modal"]').click(function(event) {
        var modaltoshow = $(this).attr("data-target");
        $(modaltoshow).show();
    }),
    $('.modal .close').click(function(event) {
        var modaltoshow = $(this).attr("data-target");
        $('.modal').hide();
    }),
    jQuery(document).on("click", ".bundle-faq", function(e) {
        var t = jQuery(this).attr("data-product");
        jQuery(t).show();
    }),
    jQuery(document).on("click", "#ingredients-modal .close", function(e) {
        jQuery("#ingredients-modal").hide();
    });
jQuery(document).on("click", ".ingredients-modal .close", function(e) {
    jQuery(".ingredients-modal").hide();
});
var links = document.links;
for (let e = 0, t = links.length; e < t; e++) links[e].hostname !== window.location.hostname && ((links[e].target = "_blank"), (links[e].rel = "nofollow noopener"));
$(".account-icon.logged-in").hover(
        function() {
            $(".site-nav a.header-link ").show();
        },
        function() {
            $(".site-nav a.header-link ").fadeOut(3e3);
        }
    ),
    $(".site-nav a.header-link").hover(
        function() {
            $(".site-nav a.header-link ").show();
        },
        function() {
            $(".site-nav a.header-link ").fadeOut(3e3);
        }
    ),
    $(".panel-collapse").on("show.bs.collapse", function() {
        $(this).siblings(".panel-heading").addClass("active");
    }),
    $(".panel-collapse").on("hide.bs.collapse", function() {
        $(this).siblings(".panel-heading").removeClass("active");
    }),
    $(".product-video")
    .parent()
    .click(function() {
        $(this).children(".product-video").get(0).paused ?
            ($(this).children(".product-video").get(0).play(), $(this).children(".playpause").fadeOut()) :
            ($(this).children(".product-video").get(0).pause(), $(this).children(".playpause").fadeIn());
    }),
    $(".video.kin-desktop")
    .parent()
    .click(function() {
        $(this).children(".video.kin-desktop").get(0).paused ?
            ($(this).children(".video.kin-desktop").get(0).play(), $(this).children(".playpause").fadeOut()) :
            ($(this).children(".video.kin-desktop").get(0).pause(), $(this).children(".playpause").fadeIn());
    }),
    $(".video.kin-mobile")
    .parent()
    .click(function() {
        $(this).children(".video.kin-mobile").get(0).paused ?
            ($(this).children(".video.kin-mobile").get(0).play(), $(this).children(".playpause").fadeOut()) :
            ($(this).children(".video.kin-mobile").get(0).pause(), $(this).children(".playpause").fadeIn());
    });

$(document).ready(function() {
    $('.filter-item').on("click", function(t) {
        $('.filter-item').removeClass("active");
        var filter = $(this).find("span").html();
        $(this).addClass("active");

        $(".collection .grid-item").each(function() {
            if ($(this).attr("data-tags").indexOf(filter) != -1) {
                $(this).show();
            } else {
                $(this).hide();
            }
        });
    });
});

$(document).ready(function() {
    var parameters = getQueryStringParameters();
    var keyvalue = "";
    if (parameters != null || parameters != '') {
        $.each(parameters, function(key, value) {
            if (key == "filter") {
                var filter = value;
                var newfilter = "";
                $('.filter-item').removeClass("active");
                if ($('.filter-item').length > 0) {

                    $(".filter-item").each(function() {
                        if ($(this).attr("data-filter") == filter) {
                            $(this).addClass("active");
                            newfilter = $(this).find("span").html();
                        }
                    });

                    $(".collection .grid-item").each(function() {
                        if ($(this).attr("data-tags").indexOf(newfilter) != -1) {
                            $(this).show();
                        } else {

                            $(this).hide();
                        }
                    });
                }
            }
        });
    }
});

$("body").on("click", ".btn.main-add.quick", function(e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    var qty_id = $(this).attr("data-qty");
    if ($(this).attr("selling_plan")) {
        Shopify.addItemToCart(variant_id, $(this).attr("selling_plan"), qty_id);
    } else {
        Shopify.addItem(variant_id);
    }
});

$("body").on("click", ".btn.main-add.reg", function(e) {
    e.preventDefault();
    var variant_id = $(this).attr("data-id");
    
    if ($(this).attr("selling_plan")) {
        Shopify.addItemToCart(variant_id, $(this).attr("selling_plan"), 1);
    } else {
        Shopify.addItem(variant_id);
    }
});

function handleChangeSubscriptionFrequency(selection) {
  const form = selection.closest(".form-wrapper");
  const subscriptionWrapper = form.find(".js-subscription");
  subscriptionWrapper.attr("data-selected-selling-plan-name", selection.data("selling-plan-name"));
  updateVariantP(selection, "Subscribe");
}

function handleClickSubscriptionVariant(item) {
  const variantId = item.val();
  const form = item.closest(".form-wrapper");
  const select = form.find(`.js-frequency-select[data-variant="${variantId}"]`);
  if(select.length) {
    form.find(".js-frequency-select").hide();
    select.show();
    const subscriptionWrapper = form.find(".js-subscription");
    const previousSellingPlanName = subscriptionWrapper.attr("data-selected-selling-plan-name");
    let sellingPlanOption = select.find("option").eq(0);
    if(previousSellingPlanName) {
      const matchingSellingPlanOption = select.find(`option[data-selling-plan-name="${previousSellingPlanName}"]`);
      if(matchingSellingPlanOption?.length) {
        sellingPlanOption = matchingSellingPlanOption;
      }
    }
    select.val(sellingPlanOption.val());
    handleChangeSubscriptionFrequency(sellingPlanOption);
    //updateVariantP(sellingPlanOption, "Subscribe");
  } else {
    updateVariantP(item, "Subscribe");
  }
}

function loadSingle($form) {
  $form.find('.subscription-purchase-wrapper').removeClass("select").addClass("unselected");
  $form.find('.single-purchase-wrapper').addClass("select").removeClass("unselected");
  if ($form.find('.single-purchase-wrapper .default').length > 0) {
    updateVariantP($form.find('.single-purchase-wrapper .default input'), "Add to Cart");
    $form.find('.single-purchase-wrapper .default').removeClass('default');
  } else {
    if ($form.find('.single-purchase-wrapper .last-selected').length > 0) {
      updateVariantP($form.find('.single-purchase-wrapper .product-variants li.last-selected input'), "Add to Cart");
    } else {
      updateVariantP($form.find('.single-purchase-wrapper .product-variants li:first input'), "Add to Cart");
    }
  }
}

function loadSubscription($form) {
  $form.find('.subscription-purchase-wrapper').addClass("select").removeClass("unselected");
  $form.find('.single-purchase-wrapper').removeClass("select").addClass("unselected");
  let $variant = $form.find('.subscription-purchase-wrapper .product-variants li:first input');
  if ($form.find('.subscription-purchase-wrapper .last-selected').length > 0) {
    $variant = $form.find('.subscription-purchase-wrapper .product-variants li.last-selected input');
  }
  handleClickSubscriptionVariant($variant);
}

function updateURL(item) {
  let variantId = item.val();
	if (variantId == ""){
		variantId = document.querySelector(".product-variants li.selected input").value;
	}
	let input = document.querySelector(`#radio_${variantId}`);
  if (!variantId || !input.dataset) return;
  window.history.replaceState({}, '', `${input.dataset.url}?variant=${variantId}`);
}

function updateVariantP(item, btntext) {
  const $form = item.closest(".form-wrapper");
  const ctaButton  = $form.find(".main-add");
  let variantId = item.val();
  if(item.attr("data-variant-id")) {
    variantId = item.attr("data-variant-id");
  }
  ctaButton.attr("data-id", variantId);
  ctaButton.attr("data-qty", item.attr("data-qty"));
  ctaButton.attr("selling_plan", item.attr("selling_plan") ? item.attr("selling_plan") : '');
  
  $form.find('.js-variant').removeClass("selected");
  
  //item.closest("li").addClass("selected");
  item.prop("checked");

  const variantSingle = $form.find(`.js-variant-single[data-variant="${variantId}"]`);
  const inputSingle = variantSingle.find("input");
  const variantSubscription = $form.find(`.js-variant-subscription[data-variant="${variantId}"]`);
  const inputSubscription = variantSubscription.find("input");

  if (btntext == "Add to Cart") {
    $form.find(`.js-variant-single[data-variant="${variantId}"]`).addClass("selected");

    if (item.closest(".item-slim").length > 0){
      $form.find(".main-add span").html(btntext + "-"+ item.attr("product-price"));
    } else {
      $form.find(".main-add span").html(btntext); 
    }
  
    $form.find('.product-price').html(item.attr("product-price"));
    
    let priceSubscription = "";
    if(inputSubscription.length) {
      priceSubscription = inputSubscription.attr("product-price");
    }
    $form.find('.recharge-price').html(priceSubscription);
    
    $form.find('.js-subscription-details').hide();

    if (item.attr("inventory") <= 0) {
      ctaButton.addClass("out-of-stock");
    } else {
      ctaButton.removeClass("out-of-stock");
    }
  } else {
    $form.find(`.js-variant-subscription[data-variant="${variantId}"]`).addClass("selected");

    if (item.closest(".item-slim").length > 0){
      item.closest(".grid-item").find(".hero-subtitle").html( item.attr("product-price"));
      $form.find(".main-add span").html(btntext);
    } else {
      $form.find(".main-add span").html(btntext); 
    }
  
    $form.find('.recharge-price').html(item.attr("product-price"));
    $form.find('.js-subscription-details').show();

    let priceSingle = "";
    if(inputSingle.length) {
      priceSingle = inputSingle.attr("product-price");
    }
    $form.find('.product-price').html(priceSingle);
  }

  $form.find('.single-purchase li').removeClass("last-selected");
  $form.find('.subscription-purchase li').removeClass("last-selected");

  //item.closest("li").addClass("last-selected");
  variantSingle.addClass("last-selected");
  variantSubscription.addClass("last-selected");
  if (item.closest(".form-wrapper").find(".included").length > 0) {
    var packsize = item.attr("include-size");
    item.closest(".form-wrapper").find(".included .inner-card .pack-size-wrapper").html(packsize);
  }
}

$(document).ready(function() {
	if(document.baseURI.includes("products/")){
		updateURL($(this))
	}
  $(".product-variants.single-purchase li input").click(function(e) {
		if(document.baseURI.includes("products/")){
			updateURL($(this))
		}
    updateVariantP($(this), "Add to Cart");
  });
  $(".product-variants.subscription-purchase li input").click(function(e) {
    handleClickSubscriptionVariant($(this));
  });
  $(".product-variants.subscription-purchase .js-frequency-select").on("change", function(e) {
    const selected = $(this).find(":selected");
    handleChangeSubscriptionFrequency(selected);
  });
  
  $("body").on("click", ".unselected", function(e) {
    const $form = $(this).closest(".form-wrapper");
    $(this).closest(".unselected").find(" input[name=purchase-type]").prop("checked", true);
    if ($(this).closest(".unselected").find(" input[name=purchase-type]").val() == "recharge") {
      loadSubscription($form);
    } else {
      loadSingle($form);
    } 
  });
});

$(".form-wrapper input[name=purchase-type]").change(function() {
  const $form = $(this).closest(".form-wrapper");
  if ($(this).val() == "recharge") {
    loadSubscription($form);
  } else {
    loadSingle($form);
  }
});
    
// Dropdown Menu Fade    
$(document).ready(function() {
    $(".mega-menu-drop").hover(
        function() {
            $('.mega-menu').show();
        },
        function() {
            $('.mega-menu').hide();
        });
    $(".mini-menu-drop").hover(
        function() {
            $('.mini-menu').show();
        },
        function() {
            $('.mini-menu').hide();
        });
});

var drawer = function() {
    Element.prototype.closest || (Element.prototype.matches || (Element.prototype.matches = Element.prototype.msMatchesSelector || Element.prototype.webkitMatchesSelector), Element.prototype.closest = function(t) {
        var e = this;
        if (!document.documentElement.contains(this)) return null;
        do {
            if (e.matches(t)) return e;
            e = e.parentElement
        } while (null !== e);
        return null
    });
    var t = 50,
        e = 350,
        n = "is-active",
        r = "is-visible",
        o = "[data-drawer-target]",
        i = "[data-drawer-trigger]",
        a = "[data-drawer-close]",
        l = function(t) {
            "true" === t.getAttribute("aria-expanded") ? t.setAttribute("aria-expanded", !1) : t.setAttribute("aria-expanded", !0)
        },
        c = function(t) {
            var i = t.closest(o),
                a = document.querySelector('[aria-controls="' + i.id + '"');
            i.classList.remove(r), document.documentElement.style.overflow = "", l(a), setTimeout(function() {
                i.classList.remove(n)
            }, e)
        };
    document.addEventListener("click", function(e) {
        var o, s, u = e.target,
            d = u.closest(i),
            m = u.closest(a);
        d && (o = d, (s = document.getElementById(o.getAttribute("aria-controls"))).classList.add(n), document.documentElement.style.overflow = "hidden", l(o), setTimeout(function() {
            s.classList.add(r)
        }, t)), m && c(m), (d || m) && e.preventDefault()
    }, !1), document.addEventListener("keydown", function(t) {
        if ("Escape" === t.key || 27 === t.keyCode) {
            var e, r = document.querySelectorAll(o);
            for (e = 0; e < r.length; ++e) r[e].classList.contains(n) && c(r[e])
        }
    }, !1)
};

function getCookie(t) {
    for (var e = t + "=", n = document.cookie.split(";"), r = 0; r < n.length; r++) {
        for (var o = n[r];
            " " == o.charAt(0);) o = o.substring(1);
        if (0 == o.indexOf(e)) return o.substring(e.length, o.length)
    }
    return ""
}
drawer(), $(document).ready(function() {
    $(".qtyplus").click(function(t) {
        t.preventDefault();
        var e = parseInt(jQuery(this).parent().find('input[type="number"].line-item-qty').val());
        jQuery(this).parent().find('input[type="number"].line-item-qty').val(e + 1)
    }), jQuery(".qtyminus").click(function(t) {
        t.preventDefault();
        var e = parseInt(jQuery(this).parent().find('input[type="number"].line-item-qty').val());
        jQuery(this).parent().find('input[type="number"].line-item-qty').val(e - 1)
    });
    let t = getCookie("upselProduct");
    null != t && t.length, $(".select2-results__option:contains('48')").hide(), $('.cart__meta:contains("Auto")').length > 0 && $(".cart__root").addClass("recharge");
    var e = getCookie("discount");
    null != e && e.length > 1 && ($("#cart_form").attr("action", "/cart?discount=" + e), $(".discount-wrapper").html("Discount Code Applied at checkout"))
});

function getQueryStringParameters(){var t,r={},e=document.URL.split("?")[1];if(null!=e){e=e.split("&");for(var n=0;n<e.length;n++)r[(t=e[n].split("="))[0]]=t[1]}return r}

function getCookie(o){for(var t=o+"=",n=document.cookie.split(";"),e=0;e<n.length;e++){for(var i=n[e];" "==i.charAt(0);)i=i.substring(1);if(0==i.indexOf(t))return i.substring(t.length,i.length)}return""}


$(document).ready(function() {
    var e = getQueryStringParameters();
    null == e && "" == e || $.each(e, function(e, a) {
        "earlyaccess" == e && "yes" == a && (document.cookie = "earlyaccess=yes;path=/")
    });
   $('#wholesale-modal .close').on("click", function (t) {$('#wholesale-modal').hide();
       var d = new Date(); d = new Date(d.getTime() + 1000 *86400 * 2); document.cookie = 'wholesale=closed; expires=' + d.toGMTString() + ';' +'path=/';
    });
   $('#international-modal .close').on("click", function (t) {
       $('#international-modal').hide();
       var d = new Date(); d = new Date(d.getTime() + 1000 *86400 * 2); document.cookie = 'international=closed; expires=' + d.toGMTString() + ';' +'path=/';
    });
});



    $(".child-trigger").on("click", function (e) {
        e.preventDefault(),
            $(".top-level-menu").hide(),
            $(".grandchild-level").hide(),
            $(".grandchild-level ul").hide(),
            $(".child-level ul").hide(),
            $(".back-arrow ").hide(),
            $(".child-level").show(),
            $("." + $(this).attr("data-trigger")).show();
    }),
    $(".grandchild-trigger").on("click", function (e) {
        e.preventDefault(),
            $(".top-level-menu").hide(),
            $(".child-level").hide(),
            $(".grandchild-level ul").hide(),
            $(".child-level ul").hide(),
            $(".back-arrow ").hide(),
            $(".grandchild-level").show(),
            $("." + $(this).attr("data-trigger")).show();
    }),
    $(".top-level-trigger").on("click", function (e) {
        e.preventDefault(), $(".child-level").hide(), $(".grandchild-level ul").hide(), $(".child-level ul").hide(), $(".grandchild-level").hide(), $(".back-arrow ").hide(), $(".top-level-menu").show();
    });

$("body").on("click", ".bundle-remove", function(e) {
    e.preventDefault();
    // remove all items to cart
      var product_data ="[";
      var bundleToRemove = $(this).closest(".bundled-group").attr("data-bundle");
      var total = $('.bundled.'+bundleToRemove).length;
      $('.bundled.'+bundleToRemove).each(function(index) {
        var idval = $(this).attr("data-id");        
          if (index === total - 1) {
               product_data = product_data + idval+"]";
          }else{
               product_data = product_data +idval+',';
          }
     });
   const obj = JSON.parse(product_data);
   removeSeveralFromCart( obj );
});

const removeSeveralFromCart = (productIDS) => {
    let formData = {
        'updates': {}
    };

    var productID;
    for (productID in productIDS) {
        formData['updates'][parseInt(productIDS[productID])] = 0;
    }

    let info = fetch('/cart/update.js', {
        method: 'POST',
        headers: {
            'Content-Type': 'application/json'
        },
        body: JSON.stringify(formData)
    }).then(response => response.json())
      .then(data => {
       updateDrawer("remove");
        return data
    }).catch((error) => {
        console.error('Error:', error);
    });
}

function updateBundleSub(bundleToUpdate) {
      var product_data ="[";
        var total = $('.bundled.'+bundleToUpdate).length;
      $('.bundled.'+bundleToUpdate).each(function(index) {
        var qtyval = $(this).attr("data-qty");
        var lineval = $(this).attr("data-index");
        var idval =  $(this).attr("data-id");
        var bundleid = $(this).attr("data-bundle");
        var selling_plan = ',"selling_plan":'+$(this).attr("data-sub-id");
        if (qtyval > "0"){
          if (index === total - 1) {
               product_data = product_data + '{"id":'+idval+',"quantity":'+qtyval+selling_plan+',"properties":{"Bundle": "'+bundleid+'"}}]';
               const obj = JSON.parse(product_data);

                  var data = {
                  items: 
                    obj
                }
            Shopify.removeItemLineLast(idval,data);
          }else{
            Shopify.removeItemLine(idval);
            product_data = product_data + '{"id":'+idval+',"quantity":'+qtyval+selling_plan+',"properties":{"Bundle": "'+bundleid+'"}},';
          }   
           
        }
     });
 

  }
jQuery.fn.reverse = function() {
    return this.pushStack(this.get().reverse(), arguments);
};

document.addEventListener("DOMContentLoaded", function () {
  const body = document.body;

  window.addEventListener("scroll", function () {
    if (window.scrollY > 50) {
      body.classList.add("scrolled");
    } else {
      body.classList.remove("scrolled");
    }
  });
});